import React from "react";
import { HashRouter as BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { SnackbarProvider } from "./utils/snackbar";
import { ThemeModeProvider } from "./context/ThemeContext";

import AdminLayout from "./pages/admin/AdminLayout";
import DashboardHome from "./pages/admin/DashboardHome";
import ManageProducts from "./pages/admin/ManageProducts";
import ManageCategories from "./pages/admin/ManageCategories";
import ManageOrders from "./pages/admin/ManageOrders";
import Profile from "./pages/admin/Profile";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";

import ManageRiderOrders from "./pages/admin/ManageRiderOrders";
import ManageUsers from "./pages/admin/ManageUsers";
import RiderTracking from "./pages/admin/RiderTracking";

import RiderLayout from "./pages/rider/RiderLayout";
import RiderHome from "./pages/rider/RiderHome";
import RiderPresence from "./pages/rider/RiderPresence";

import ManageRiders from "./pages/admin/ManageRiders";
import CustomerMapDashboard from "./pages/admin/CustomerMapDashboard";
import LiveTracking from "./pages/admin/LiveTracking";
import AdminFeaturedProducts from "./pages/admin/AdminFeaturedProducts";
import AdminFlashDeals from "./pages/admin/AdminFlashDeals";
import AdminQuickPicks from "./pages/admin/AdminQuickPicks";
import ImageRecovery from "./pages/admin/ImageRecovery";
import POSTerminal from "./pages/admin/POSTerminal";
import InventoryManagement from "./pages/admin/InventoryManagement";
import ShiftManagement from "./pages/admin/ShiftManagement";
import SalesReports from "./pages/admin/SalesReports";
import ManageCustomers from "./pages/admin/ManageCustomers";
import ManageDiscounts from "./pages/admin/ManageDiscounts";
import SupplierManagement from "./pages/admin/SupplierManagement";

// CMS & Enterprise pages
import ContentManager from "./pages/admin/ContentManager";
import PromoManager from "./pages/admin/PromoManager";
import CampaignManager from "./pages/admin/CampaignManager";
import AppConfiguration from "./pages/admin/AppConfiguration";
import AdvancedAnalytics from "./pages/admin/AdvancedAnalytics";
import CustomerSegments from "./pages/admin/CustomerSegments";
import DealsOfDay from "./pages/admin/DealsOfDay";
import NotificationCenter from "./pages/admin/NotificationCenter";
import AuditLogPage from "./pages/admin/AuditLogPage";
import SystemHealth from "./pages/admin/SystemHealth";

export default function App() {
  return (
    <ThemeModeProvider>
    <BrowserRouter>
      <SnackbarProvider>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />

            {/* ---------------- ADMIN ---------------- */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardHome />} />
              <Route path="products" element={<ManageProducts />} />
              <Route path="categories" element={<ManageCategories />} />
              <Route path="orders" element={<ManageOrders />} />
              <Route path="profile" element={<Profile />} />

              {/* EXISTING */}
              <Route path="rider-orders" element={<ManageRiderOrders />} />
              <Route path="users" element={<ManageUsers />} />
              <Route path="tracking" element={<RiderTracking />} />
              <Route
                path="customer-tracking"
                element={<CustomerMapDashboard />}
              />
              <Route
                path="live-tracking"
                element={<LiveTracking />}
              />

              <Route
                path="flash-deals"
                element={<AdminFlashDeals />}
              />

              <Route path="riders" element={<ManageRiders />} />
              <Route path="featured-products" element={<AdminFeaturedProducts/>}/>
              <Route path="quick-picks" element={<AdminQuickPicks />} />
              <Route path="image-recovery" element={<ImageRecovery />} />

              {/* POS & SUPERMARKET ROUTES */}
              <Route path="pos" element={<POSTerminal />} />
              <Route path="inventory" element={<InventoryManagement />} />
              <Route path="shifts" element={<ShiftManagement />} />
              <Route path="reports" element={<SalesReports />} />
              <Route path="customers" element={<ManageCustomers />} />
              <Route path="discounts" element={<ManageDiscounts />} />
              <Route path="suppliers" element={<SupplierManagement />} />

              {/* CMS & ENTERPRISE ROUTES */}
              <Route path="content" element={<ContentManager />} />
              <Route path="promo" element={<PromoManager />} />
              <Route path="campaigns" element={<CampaignManager />} />
              <Route path="app-config" element={<AppConfiguration />} />
              <Route path="analytics" element={<AdvancedAnalytics />} />
              <Route path="segments" element={<CustomerSegments />} />
              <Route path="deals" element={<DealsOfDay />} />
              <Route path="notification-center" element={<NotificationCenter />} />
              <Route path="audit-log" element={<AuditLogPage />} />
              <Route path="system" element={<SystemHealth />} />
            </Route>

            {/* ---------------- RIDER ---------------- */}
            <Route path="/rider" element={<RiderLayout />}>
              <Route index element={<RiderHome />} />
              <Route path="presence" element={<RiderPresence />} />
            </Route>

            {/* fallback */}
            <Route path="*" element={<Login />} />
          </Routes>
        </AuthProvider>
      </SnackbarProvider>
    </BrowserRouter>
    </ThemeModeProvider>
  );
}
